module.exports = __webpack_public_path__ + "img/novadia.e6b7f3bd.png";